import { render, staticRenderFns } from "./CardCredits.vue?vue&type=template&id=50e8ea16&scoped=true&"
import script from "./CardCredits.vue?vue&type=script&lang=js&"
export * from "./CardCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8ea16",
  null
  
)

export default component.exports